/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Minus = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 7 1">
      <path d="M6.5,1 L0.5,1 C0.224,1 0,0.776 0,0.5 C0,0.224 0.224,0 0.5,0 L6.5,0 C6.776,0 7,0.224 7,0.5 C7,0.776 6.776,1 6.5,1" />
    </BaseSvgIcon>
  )
}

export default Minus
